import React, { Fragment } from "react"
import Studio from "../Studio"
import WithPages from "data/wrappers/WithPages"
import PageTable from "../components/PageTable"
import PageTitle from "ui/components/PageTitle"
import Breadcrumbs from "ui/components/Breadcrumbs"

// import RecordTable from "features/studio/components/RecordTable"
import NewPageButton from "../components/NewPageButton"
import { Container, Section, SectionHeader, Card, Button } from "ui"
import WithApp from "data/wrappers/WithApp"
import AttributeList from "../../records/components/AttributeList"
import WithStacks from "data/wrappers/WithStacks"
import StandardPagesListEditor from "../components/StandardPagesListEditor"

export default class AppDetailPage extends React.Component {
    render() {
        return (
            <Studio color="yellow">
                <WithApp appId={this.props.params.appId}>
                    {({ app, onChange }) => {
                        const changeStandardPages = pages =>
                            onChange({
                                options: { ...app.options, standard_pages: pages },
                            })
                        return (
                            <Fragment>
                                <Container marginBottom="medium" spaced>
                                    <Section margin="none" padding="none">
                                        <Breadcrumbs crumbs={[{ label: "Apps", link: "/apps/" }]} />
                                        <PageTitle>
                                            {app.name}{" "}
                                        </PageTitle>
                                    </Section>
                                    <Container>
                                        <WithStacks>
                                            {({ selectedStack }) => (
                                                <a
                                                    href={
                                                        "//" + selectedStack.base_url + app.url
                                                    }
                                                    target={"_blank"}
                                                >
                                                    <Button size="small" sideMargin="small" margin={"small"}>View App</Button>
                                                </a>
                                            )}
                                        </WithStacks>
                                        <WithStacks>
                                            {({ selectedStack }) => (
                                                <a
                                                    href={"/preview" + app.url}
                                                >
                                                    <Button size="small" sideMargin="small" margin={"small"}>Preview App</Button>
                                                </a>
                                            )}
                                        </WithStacks>
                                    </Container>
                                </Container>
                                <SectionHeader>App Settings</SectionHeader>
                                <Card style={{ marginTop: 10, marginBottom: 30 }}>
                                    {" "}
                                    <Container wrapItems>
                                        <AttributeList
                                            editable
                                            data={app}
                                            onChange={onChange}
                                            fields={[
                                                { api_name: "name", label: "Name" },
                                                { api_name: "url", label: "URL" },
                                            ]}
                                        />
                                    </Container>
                                </Card>
                                <Container margin="none" spaced>
                                    <SectionHeader>Custom Pages</SectionHeader>
                                    <Container>
                                        <NewPageButton />
                                    </Container>
                                </Container>
                                <WithPages>
                                    {({ pages, onChange }) => (
                                        <PageTable
                                            onChange={onChange}
                                            data={pages}
                                            filters={{
                                                app_id: this.props.params.appId,
                                            }}
                                            hideApp={true}
                                        />
                                    )}
                                </WithPages>
                                {/* <SectionHeader style={{ marginTop: 30 }}>
                                    Standard Pages
                                </SectionHeader>

                                <Card style={{ marginTop: 5, marginBottom: 30 }}>
                                    <StandardPagesListEditor
                                        standardPages={app.options.standard_pages}
                                        onChange={changeStandardPages}
                                    />
                                </Card> */}
                            </Fragment>
                        )
                    }}
                </WithApp>
            </Studio>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/studio/containers/AppDetailPage.js